import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { MODAL_STEPS } from "../../../../constants/modal";
import { useIsMobile } from "../../../../utils";
import { useMediaQuery } from "react-responsive";
import { uxGender } from "../../../../configs";

import "./index.css";

interface BackArrowButtonProps {
  step: any | null;
  isShoesProduct: boolean;
  isSportyAndRich: boolean;
  brandName?: string;
  handleGoBack: () => void;
}

export const BackArrowButton = ({
  step,
  isShoesProduct,
  isSportyAndRich,
  brandName,
  handleGoBack,
}: BackArrowButtonProps) => {
  const isMobile = useIsMobile();

  const isLargeHeightRelative = useMediaQuery({
    maxHeight: 830,
    minWidth: 767,
  });

  const isMediumHeightRelative = useMediaQuery({
    maxHeight: 678,
    minWidth: 767,
  });

  const shouldShow =
    step &&
    step?.number >= 0 &&
    ![
      MODAL_STEPS.CONSENT.number,
      MODAL_STEPS.GENDER.number,
      MODAL_STEPS.INTRO.number,
      uxGender ? MODAL_STEPS.INTRO_MOBILE.number : false,
      MODAL_STEPS.ERROR.number,
      MODAL_STEPS.RESULT.number,
      MODAL_STEPS.UNAVAILABLE_RESULT.number,
      MODAL_STEPS.ANTI_BRACKETING.number,
    ].includes(step?.number) &&
    !isShoesProduct;

  if (!shouldShow) return null;

  const top =
    isLargeHeightRelative && brandName !== "Sporty & Rich"
      ? "5px"
      : isMediumHeightRelative && brandName === "Sporty & Rich"
      ? "5px"
      : "inherit";

  return (
    <div
      className="left-arrow"
      style={{ position: "absolute", left: "20px", top }}
    >
      <IconButton
        sx={{
          zIndex: 1,
          padding: "3px",
          borderRadius: "5px",
          position: "fixed",
          top: isShoesProduct && !isSportyAndRich ? "-15px" : "15px",
        }}
        onClick={handleGoBack}
      >
        <ArrowBackIcon
          style={{
            color: "black",
            width: isMobile ? "16px" : "18px",
            height: isMobile ? "16px" : "18px",
          }}
        />
      </IconButton>
    </div>
  );
};

export default BackArrowButton;
